export default __webpack_public_path__ + "static/media/one_tap_wordmark_white.3dbfaf16.svg";